<script setup>
const sections = [
  { route: 'catalogProducts', label: 'Товари', icon: 'bi-box-seam' },
  { route: 'catalogCategories', label: 'Категорії', icon: 'bi-diagram-3' },
  { route: 'catalogBrands', label: 'Бренди', icon: 'bi-award' },
  { route: 'catalogCharacteristics', label: 'Характеристики', icon: 'bi-sliders' },
]
</script>

<template>
  <section class="catalog-workspace text-start">
    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4">
      <div>
        <h1 class="h3 mb-1">Каталог</h1>
        <p class="text-muted mb-0">Товари, структура та мультимовні характеристики</p>
      </div>
      <nav class="nav nav-pills catalog-nav" aria-label="Розділи каталогу">
        <router-link v-for="section in sections" :key="section.route" :to="{ name: section.route }" class="nav-link">
          <i class="bi me-2" :class="section.icon" aria-hidden="true"></i>{{ section.label }}
        </router-link>
      </nav>
    </div>
    <router-view />
  </section>
</template>
